<!-- 证书跳转 -->

<template>
    <div class="uk-flex uk-flex-middle border-box" style="overflow:hidden">
        <!--<div style="margin:0 auto; ">-->
        <!--    <a-->
        <!--        target="_blank"-->
        <!--        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011202002386"-->
        <!--        class="icon-margin uk-flex uk-flex-middle"-->
        <!--        style="text-decoration:none;height:20px;line-height:20px;"-->
        <!--    >-->
        <!--        <img :src="filing" />-->
        <!--        <p :style="`display:inline-block;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color: ${color}`">粤公网安备 44011202002457号</p>-->
        <!--    </a>-->
        <!--</div>-->
        <a
            v-if="lang === 'zh_CN'"
            href="https://xyt.xcc.cn/getpcInfo?sn=1669622052933296128&language=CN&certType=8&url=*.jr-tms.com"
            target="_blank"
            style="position: relative;display: inline-block;height: 38px;"
        >
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/web/1669622052933296128=*.jr-tms.com.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"
        /></a>
        <a
            v-else-if="lang === 'en_US'"
            href="https://xyt.xcc.cn/getpcInfo?sn=1669622052933296128&language=EN&certType=8&url=*.jr-tms.com"
            target="_blank"
            style="position: relative;display: inline-block;height: 38px;"
        >
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/web/1669622052933296128=*.jr-tms.comen.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"
        /></a>
    </div>
</template>

<script>
import { getLanguage } from '@/lang';
import filing from '@/assets/filing/filing.png';
export default {
    props: {
        color: {
            type: String,
            default: '#939393'
        }
    },
    data() {
        return {
            getLanguage,
            filing
        };
    },
    computed: {
        lang() {
            return getLanguage();
        }
    }
};
</script>
